import { Link } from '~components'
import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Images } from '~data'
import Footer from "./style"



export default function FooterOne() {
    const [isMobile, setIsMobile] = useState(false)
    useEffect(() => {
        // if browser
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setIsMobile(true)
            } else {
                setIsMobile(false)
            }
        }
    }, [])
    return (
        <Footer backgroundColor="#F3f4f6">
            <Container>
                <Footer.Box pbXL="95px">
                    <Row>
                        <Col xs="12" className="col-lg-4 col-md-8 col-xs-10">
                            <Footer.Widgets className="footer-widgets footer-widgets--l7">
                                {/* Brand Logo*/}
                                <Footer.Box mb="30px">
                                    <Link to="#">
                                        <img src={Images.FooterSix.LogoBlack} alt="logo" />
                                    </Link>
                                </Footer.Box>
                                <Footer.Text mb="36px">
                                    DocPile is a secure document storage platform - combining documents with AI to optimise your existing distributed workflow in a single space.</Footer.Text>

                            </Footer.Widgets>
                        </Col>
                        <Col xs="12" className="col-xl-8">
                            <Row>
                                {!isMobile ? (
                                    <Col xs="12" className="col-md-4 col-xs-6">
                                        <Footer.Widgets>
                                            <Footer.Title>Company</Footer.Title>
                                            <Footer.List>
                                                {/* <Footer.ListItems>
                                                    <a href="/about-us">About
                                                        us</a>
                                                </Footer.ListItems> */}
                                                <Footer.ListItems>
                                                    <Link to="/privacy-policy">Privacy
                                                        Policy</Link>
                                                </Footer.ListItems>
                                                <Footer.ListItems>
                                                    <Link to="/terms-and-conditions">Terms &amp;
                                                        Conditions</Link>
                                                </Footer.ListItems>
                                                <Footer.ListItems>
                                                    <a href="/contact-us">Contact us</a>
                                                </Footer.ListItems>
                                            </Footer.List>
                                        </Footer.Widgets>
                                    </Col>
                                ) : ""}

                                <Col xs="12" className="col-md-4 col-xs-6">
                                    <Footer.Widgets>
                                        <Footer.Title>Contact Details</Footer.Title>
                                        <Footer.Address className="widgets-address">
                                            <Footer.AddressItem>
                                                <i className="fa fa-map-marker-alt" />
                                                <span>Level 2, 11 York Street <br className="d-block" />
                                                    Sydney, NSW 2000</span>
                                            </Footer.AddressItem>
                                            <Footer.AddressItem>
                                                <i className="fa fa-phone-alt" />

                                                <a href="#">+61 (405) 925 085
                                                </a>
                                            </Footer.AddressItem>
                                            <Footer.AddressItem>
                                                <i className="fa fa-envelope" />
                                                <a href="mailto:info@medcartel.com">hello@docpile.io</a>
                                            </Footer.AddressItem>
                                        </Footer.Address>
                                    </Footer.Widgets>
                                </Col>
                                <Col xs="12" className="col-md-4 col-xs-7">
                                    <Footer.Widgets>
                                        <Footer.Title>Follow us on social media</Footer.Title>
                                        <Footer.Text>Get the latest updates right in your inbox.</Footer.Text>
                                        <Footer.SocialShare>
                                            <Footer.Box pt="11px" pb="30px">
                                                <Footer.SocialShareItem>
                                                    <a href="https://www.linkedin.com/company/docpile">
                                                        Linkedin
                                                    </a>
                                                </Footer.SocialShareItem>
                                                <Footer.SocialShareItem>
                                                    <a href="https://twitter.com/docpileapp">
                                                        Twitter
                                                    </a>
                                                </Footer.SocialShareItem>
                                                <Footer.SocialShareItem>
                                                    <a href="https://www.youtube.com/channel/UCebR2mMpXGlAEotp0BKhmtg">
                                                        Youtube
                                                    </a>
                                                </Footer.SocialShareItem>
                                            </Footer.Box>
                                        </Footer.SocialShare>
                                    </Footer.Widgets>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Footer.Box>
                <Footer.Copyright>
                    <Footer.CopyrightText>© 2021 Docpile, All Rights Reserved</Footer.CopyrightText>
                </Footer.Copyright>
            </Container>
        </Footer>
    )
}